module.exports = __webpack_public_path__ + "static/media/country_jm.550be2e7.webp";